export default __webpack_public_path__ + "static/bg-earth-b4a31c6acc8a78b8a96bc2cda0af83d1.png";